import axios from 'axios';
import { routePrefix } from '../app/App';
import { SmartVacuumDTO } from '../dto/product/SmartVacuumDTO';
import { ResultsRequestBody } from '../features/filter/filterSlice';

export interface PDFReportRequestBody {
  projectData: {
    projectName: string | null;
    machine: string | null;
    contactPerson: string | null;
    notes: string | null;
  };
  filters: ResultsRequestBody;
}

export async function getResults(body: ResultsRequestBody): Promise<SmartVacuumDTO> {
  const url = `${routePrefix()}smart-vacuum`;
  const { data } = await axios.post<SmartVacuumDTO>(url, body);
  return data;
}

export async function generatePDFReport(body: PDFReportRequestBody): Promise<Blob> {
  const url = `${routePrefix()}pdf-report`;
  const res = await axios.post(url, body, { responseType: 'blob' });
  return res.data as Blob;
}
